/** access_token 过期前多久触发刷新 (5 min) */
export const TOKEN_REFRESH_THRESHOLD_MS = 5 * 60 * 1000;

/** 定时刷新检查间隔 (4h) */
export const TOKEN_REFRESH_INTERVAL_MS = 4 * 60 * 60 * 1000;

/** 刷新最大重试次数 */
export const REFRESH_MAX_RETRIES = 3;

/** 退避重试延迟 (ms): 1s → 3s → 5s */
export const REFRESH_RETRY_DELAYS = [1000, 3000, 5000];

/** API Headers — 与 OSP Index API 一致 */
export const HEADERS = {
  APP_ID: "OS-App-Id",
  FIREBASE_TOKEN: "OS-Firebase-Token",
  EMAIL: "OS-Email",
  CODE: "OS-Code",
} as const;
